import { ethers } from "ethers"
import {
  getDecimals,
  getNetwork,
  getSigner,
  getVaultContract,
} from "../../data/smart"
import { API_URL, web3ChainId, web3ChainName } from "../../constants/constants"

export const handleWithdrawReferral = async (user, amount) => {
  if (!window.ethereum) {
    throw new Error("Metamask not found")
  }

  const chainId = (await getNetwork()).chainId.toString()
  const decimals = await getDecimals()

  if (chainId !== web3ChainId) {
    console.log("User Chain ID: ", chainId, "Required Chain ID: ", web3ChainId)
    throw new Error(`Please switch to the "${web3ChainName}".`)
  }

  if (!amount || amount <= 0) {
    throw new Error("Withdrawal amount must be greater than 0")
  }

  const amt = ethers.utils.parseUnits(amount, decimals)
  const vaultContract = await getVaultContract()
  const tx = await vaultContract.withdrawReferral(amt)

  const receipt = await tx.wait()

  await fetch(`${API_URL}/web3/transactions/save`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${user.sessionToken}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      hash: receipt.transactionHash,
      chain_id: chainId,
      sum: amount,
      type: "Withdraw",
    }),
  })

  return "Withdrawal successful"
}
